module.exports = __webpack_public_path__ + "static/media/Borno State.9abd92b3.png";